import { render, staticRenderFns } from "./CompanyContent.vue?vue&type=template&id=568f61e2"
import script from "./CompanyContent.vue?vue&type=script&lang=js"
export * from "./CompanyContent.vue?vue&type=script&lang=js"
import style0 from "./CompanyContent.vue?vue&type=style&index=0&id=568f61e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports